function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { DateTime, Interval } from 'luxon';
import Weeks from './Weeks';
import Weekdays from './Weekdays';
import Header from './Header';
import { Container } from './elements';
import { getPreviousMonth, getNextMonth, minMaxDate, isSameDay, isSameMonth, isInNextMonth, isInPrevMonth, isInterval } from './helpers';
/* eslint-disable react/destructuring-assignment */

var localDateTime = DateTime.local().startOf('month');
/**
 * A DatePicker can display one or two months. It takes a value (`defaultValue` prop) to set its internal
 * selected value state, or takes the date of today by default.
 * The selected value can either be a date or an interval of Luxon.
 *
 * @return {jsx}
 */

var DatePicker = /*#__PURE__*/function (_PureComponent) {
  _inherits(DatePicker, _PureComponent);

  var _super = _createSuper(DatePicker);

  function DatePicker() {
    var _this;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      /**
       * Initial Calendar date
       * DatePicker month(s) display is based upon currentDate and will start
       * from this to iterate through the months it has to display
       */
      currentMonths: [localDateTime],

      /**
       * Selected Calendar date
       * Value of selected date of the DatePicker
       */
      selected: _this.props.defaultValue,

      /** Start date value */
      startDate: null,

      /** End date value */
      endDate: null
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentMonths", function (startDate, endDate) {
      var _this$props = _this.props,
          numberOfMonthsToDisplay = _this$props.numberOfMonthsToDisplay,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate;
      var start = minMaxDate(startDate || DateTime.local(), minDate, maxDate);
      var end = minMaxDate(endDate || DateTime.local(), minDate, maxDate);

      if (numberOfMonthsToDisplay === 2) {
        return [DateTime.min(start.startOf('month'), end.minus({
          month: 1
        }).startOf('month')), end.startOf('month')];
      }

      return [end.startOf('month')];
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value, index) {
      var rangePicker = _this.props.rangePicker;
      var _this$state = _this.state,
          previousValue = _this$state.selected,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate,
          currentMonths = _this$state.currentMonths;

      if (currentMonths.length === 1 || !rangePicker) {
        if (isInNextMonth(value, currentMonths[index])) {
          _this.handleNextMonth(index);
        } else if (isInPrevMonth(value, currentMonths[index])) {
          _this.handlePrevMonth(index);
        }
      }

      if (rangePicker) {
        var start = startDate;
        var end = endDate;

        if (!start) {
          start = value;
        } else {
          if (endDate) {
            start = value;
            end = undefined;
          } else {
            if (value >= start) {
              end = value;
            } else {
              end = start;
              start = value;
            }
          }
        }

        _this.setState({
          selected: null,
          startDate: start,
          endDate: end
        }, function () {
          _this.handleSelectedInterval();
        });
      } else {
        // First we check if the current value is different from the previsous one,
        // we never call a setState on a already selected value.
        // Then we check whether value is in the next month (w.r.t. the whole calendar)
        // or the previous month
        if (!previousValue || !isSameDay(value, previousValue)) {
          _this.setState({
            selected: value,
            startDate: null,
            endDate: null
          }, function () {
            _this.handleSelectedDate();
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePrevMonth", function (index) {
      var currentMonths = _this.state.currentMonths;

      _this.setState({
        currentMonths: currentMonths.reduceRight(function (newCurrentMonth, currentMonthValue, monthIndex) {
          if (monthIndex > index) {
            newCurrentMonth.unshift(currentMonthValue);
          } else if (monthIndex === index) {
            newCurrentMonth.unshift(getPreviousMonth(currentMonthValue));
          } else if (isSameMonth(currentMonthValue, newCurrentMonth[0]) || currentMonthValue > newCurrentMonth[0]) {
            newCurrentMonth.unshift(getPreviousMonth(newCurrentMonth[0]));
          } else {
            newCurrentMonth.unshift(currentMonthValue);
          }

          return newCurrentMonth;
        }, [])
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleNextMonth", function (index) {
      var currentMonths = _this.state.currentMonths;

      _this.setState({
        currentMonths: currentMonths.reduce(function (newCurrentMonth, currentMonthValue, monthIndex) {
          if (monthIndex < index) {
            newCurrentMonth.push(currentMonthValue);
          } else if (monthIndex === index) {
            newCurrentMonth.push(getNextMonth(currentMonthValue));
          } else if (newCurrentMonth.length > 0 && (isSameMonth(currentMonthValue, newCurrentMonth[newCurrentMonth.length - 1]) || currentMonthValue < newCurrentMonth[newCurrentMonth.length - 1])) {
            newCurrentMonth.push(getNextMonth(newCurrentMonth[newCurrentMonth.length - 1]));
          } else {
            newCurrentMonth.push(currentMonthValue);
          }

          return newCurrentMonth;
        }, [])
      });
    });

    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidMount",
    value:
    /**
     * Component lifecycle method
     * Set initial sates
     * We need to check if the default value is an interval or not
     * to set initial state correctly.
     *
     */
    function componentDidMount() {
      var defaultValue = this.props.defaultValue;

      if (isInterval(defaultValue)) {
        // Always set the current date to the start of the interval.
        this.setState({
          selected: null,
          currentMonths: this.getCurrentMonths(defaultValue.start, defaultValue.end),
          startDate: defaultValue.start,
          endDate: defaultValue.end
        });
      } else {
        this.setState({
          selected: defaultValue,
          currentMonths: this.getCurrentMonths(defaultValue, defaultValue),
          startDate: null,
          endDate: null
        });
      }
    }
    /**
     * Component lifecycle method
     *
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevDefaultValue = prevProps.defaultValue,
          prevNumberOfMonthsToDisplay = prevProps.numberOfMonthsToDisplay,
          prevMinDate = prevProps.minDate,
          prevMaxDate = prevProps.maxDate;
      var _this$props2 = this.props,
          defaultValue = _this$props2.defaultValue,
          numberOfMonthsToDisplay = _this$props2.numberOfMonthsToDisplay,
          minDate = _this$props2.minDate,
          maxDate = _this$props2.maxDate;

      if (defaultValue !== prevDefaultValue) {
        if (isInterval(defaultValue)) {
          this.setState({
            selected: null,
            currentMonths: this.getCurrentMonths(defaultValue.start, defaultValue.end),
            startDate: defaultValue.start,
            endDate: defaultValue.end
          });
        } else {
          this.setState({
            selected: defaultValue,
            currentMonths: this.getCurrentMonths(defaultValue, defaultValue),
            startDate: null,
            endDate: null
          });
        }
      } else if (numberOfMonthsToDisplay != prevNumberOfMonthsToDisplay || minDate !== prevMinDate || maxDate !== prevMaxDate) {
        var _this$state2 = this.state,
            selected = _this$state2.selected,
            startDate = _this$state2.startDate,
            endDate = _this$state2.endDate;
        this.setState({
          currentMonths: this.getCurrentMonths(startDate || selected, endDate || selected)
        });
      }
    }
  }, {
    key: "handleSelectedInterval",
    value:
    /**
     * Get selected Interval
     * Take the date range selection
     * and return as an interval
     *
     * @return {luxon.Interval}
     */
    function handleSelectedInterval() {
      var _this$state3 = this.state,
          startDate = _this$state3.startDate,
          endDate = _this$state3.endDate;
      var onDateChanged = this.props.onDateChanged;
      var isSelectedInterval = !!startDate && !!endDate;

      if (!isSelectedInterval) {
        return;
      }

      return onDateChanged(Interval.fromDateTimes(startDate, endDate));
    }
    /**
     * Get selected
     * Take the selected date
     *
     * @return {luxon.DateTime}
     */

  }, {
    key: "handleSelectedDate",
    value: function handleSelectedDate() {
      var selected = this.state.selected;
      var onDateChanged = this.props.onDateChanged;
      return onDateChanged(selected);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          locale = _this$props3.locale,
          minDate = _this$props3.minDate,
          maxDate = _this$props3.maxDate,
          displayOnlyInMonth = _this$props3.displayOnlyInMonth;
      var _this$state4 = this.state,
          currentMonths = _this$state4.currentMonths,
          selected = _this$state4.selected,
          startDate = _this$state4.startDate,
          endDate = _this$state4.endDate;
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, currentMonths.map(function (currentMonthValue, monthIndex) {
        var stringifiedDate = currentMonthValue.setLocale(locale).toLocaleString({
          month: 'long',
          year: 'numeric'
        });
        return /*#__PURE__*/React.createElement(Container, {
          key: monthIndex,
          numberOfMonthsToDisplay: currentMonths.length
        }, /*#__PURE__*/React.createElement(Header, {
          title: stringifiedDate,
          monthIndex: monthIndex,
          prev: _this2.handlePrevMonth,
          next: _this2.handleNextMonth,
          disablePrev: minDate && currentMonthValue <= minDate.startOf('month'),
          disableNext: maxDate && currentMonthValue.endOf('month') >= maxDate.endOf('month')
        }), /*#__PURE__*/React.createElement(Weekdays, {
          locale: locale
        }), /*#__PURE__*/React.createElement(Weeks, {
          currentMonth: currentMonthValue,
          selected: selected,
          minDate: minDate,
          maxDate: maxDate,
          onDateClick: function onDateClick(value) {
            return _this2.handleChange(value, monthIndex);
          },
          startDate: startDate,
          endDate: endDate,
          displayOnlyInMonth: displayOnlyInMonth
        }));
      }));
    }
  }]);

  return DatePicker;
}(PureComponent);
/** Display name. */


DatePicker.displayName = 'DatePicker';
var bool = PropTypes.bool,
    func = PropTypes.func,
    number = PropTypes.number,
    object = PropTypes.object,
    string = PropTypes.string;
/** Validation prop types. */

DatePicker.propTypes = {
  /**
   * Styled component class name
   */
  className: string,

  /**
   * Controlled selected date value
   */
  defaultValue: object,

  /**
   * Display only days in current month
   */
  displayOnlyInMonth: bool,

  /**
   * Locale used to display the weekday names
   */
  locale: string,

  /**
   * Minimum allowed date
   */
  minDate: object,

  /**
   * Maximum allowed date
   */
  maxDate: object,

  /**
   * The number of months to display (1 or 2)
   */
  numberOfMonthsToDisplay: number,

  /**
   * Handler of date change
   */
  onDateChanged: func,

  /**
   * Whether it is a date picker or a date range picker
   */
  rangePicker: bool
};
/** Default props. */

DatePicker.defaultProps = {
  className: '',
  defaultValue: localDateTime,
  displayOnlyInMonth: false,
  locale: 'en',
  minDate: null,
  maxDate: null,
  numberOfMonthsToDisplay: 1,
  onDateChanged: function onDateChanged() {},
  rangePicker: false
};
export default styled(DatePicker).withConfig({
  displayName: "DatePicker",
  componentId: "sc-17g77dz-0"
})(["display:flex;width:", ";font-weight:", ";"], function (_ref) {
  var numberOfMonthsToDisplay = _ref.numberOfMonthsToDisplay;
  return numberOfMonthsToDisplay === 2 ? 'calc((24.4rem * 2) + 2.4rem)' : '24.4rem';
}, function (_ref2) {
  var fonts = _ref2.theme.fonts;
  return fonts.weight.thick;
});